import axios, { AxiosResponse } from "axios";
import { UserFundsQuery, TransfersQueryResponse } from "./_models";
import { createApiHeaders } from "../../../../modules/auth/utils/api-headers";

const API_URL_DISBURSE = process.env.REACT_APP_DISBURSEMENT_API_URL;
const GET_USER_FUNDS_URL = `${API_URL_DISBURSE}/merchant/account-balance`;
const X_API_KEY = `${process.env.REACT_APP_DISBURSEMENT_X_API_KEY}`;

const getCheckUserFunds = (query: UserFundsQuery): any => {
  return axios
    .post(`${GET_USER_FUNDS_URL}/getdata`, query, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<TransfersQueryResponse>) => response.data);
};

const sendBalanceInfo = (merchantId: string, email: string): Promise<any> => {
  return axios
    .get(`${GET_USER_FUNDS_URL}/send-balance-info`, {
      headers: {
        ...createApiHeaders(),
      },
      params: {
        merchantId,
        email,
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data)
    .then((response: any) => response.data);
};

const sendBalanceInfoBulk = (query: any): Promise<any> => {
  return axios
    .post(`${GET_USER_FUNDS_URL}/send-balance-info`, query, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data)
    .then((response: any) => response.data);
};

export { getCheckUserFunds, sendBalanceInfo, sendBalanceInfoBulk };
